export const parseCategoryAggregations = (categoriesData = [], t, options  = {}) => {
  const {
    dedupeSubcategories = false,
    selectedCategoryId = null,
    selectedSubcategoryId = null,
    selectedIds = []
  } = options;

  const selectedIdSet = new Set(
    (selectedIds || []).map(id => String(id))
  );
  if (selectedCategoryId != null) selectedIdSet.add(String(selectedCategoryId));
  if (selectedSubcategoryId != null) selectedIdSet.add(String(selectedSubcategoryId));

  return (categoriesData || []).reduce((acc, item) => {
    const parentBuckets = item?.parentCategoryId?.buckets;
    const isParentCategory = Array.isArray(parentBuckets) && parentBuckets.length > 0;

    if (isParentCategory) {
      const parentId = Number(item.parentCategoryId.buckets[0].key);
      const parentNameRaw = item.parentCategoryName?.buckets?.[0]?.key ?? '';
      const parentDeleted = !!item.parentCategoryDeleted?.buckets?.[0]?.key;
      const parentName =
        parentDeleted && typeof t === 'function'
          ? `${parentNameRaw} ${t('filters.archive')}`
          : parentNameRaw;

      let existingParent = acc.find(cat => String(cat.id) === String(parentId));
      if (!existingParent) {
        const parentIsPicked =
          selectedIdSet.has(String(parentId)) && selectedSubcategoryId == null;
        existingParent = {
          id: parentId,
          name: parentName,
          isOpen: false,
          isPicked: !!parentIsPicked,
          subcategoryList: []
        };
        acc.push(existingParent);
      }

      const subBuckets = item.subcategories?.buckets ?? [];
      subBuckets.forEach(el => {
        const subId = Number(el?.subcategoryId?.buckets?.[0]?.key ?? el.key);
        const subNameRaw = el?.key ?? '';
        const subDeleted = !!el?.subcategoryDeleted?.buckets?.[0]?.key;
        const subName =
          subDeleted && typeof t === 'function'
            ? `${subNameRaw} ${t('filters.archive')}`
            : subNameRaw;

        if (dedupeSubcategories) {
          const exists = existingParent.subcategoryList.some(
            s => String(s.id) === String(subId)
          );
          if (exists) return;
        }

        const subPicked = selectedIdSet.has(String(subId));
        existingParent.subcategoryList.push({
          id: subId,
          name: subName,
          isPicked: !!subPicked
        });

        if (subPicked) {
          existingParent.isOpen = true;
          if (!selectedIdSet.has(String(existingParent.id))) {
            existingParent.isPicked = false;
          }
        }
      });
    } else {
      const catId = Number(item.key);
      const catNameRaw = item?.category?.buckets?.[0]?.key ?? item.key ?? '';
      const catDeleted = !!item?.categoryDeleted?.buckets?.[0]?.key;
      const catName =
        catDeleted && typeof t === 'function'
          ? `${catNameRaw} ${t('filters.archive')}`
          : catNameRaw;

      const catPicked = selectedIdSet.has(String(catId));
      acc.push({
        id: catId,
        name: catName,
        isOpen: false,
        isPicked: !!catPicked,
        subcategoryList: []
      });
    }

    return acc;
  }, []);
};